<template>
    <div class="ctm">
      <div class="container">
          <el-row :gutter="20">
                <el-col :span="24">
                    <h3>CTM 临床试验管理子系统</h3>
                    <p>临床研究管理标配的模块</p>
                </el-col>
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_1.svg">
						</div>
						<h5>项目管理</h5>
						<p class="text-center">项目立项、项目干系人、中心及研究者管理。 </p>
					</div>
                </el-col>
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_2.svg">
						</div>
						<h5>风险管理</h5>
						<p class="text-center">基于行业知识体系的问题管理、基于PD的全流程跟踪与管理，SAE全生命周期管理。 </p>
					</div>
                </el-col>
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_3.svg">
						</div>
						<h5>培训 、简历管理</h5>
						<p class="text-center">面向专业领域的模块化培训、简历管理。 </p>
					</div>
                </el-col>
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_3.svg">
						</div>
						<h5>基础数据管理</h5>
						<p class="text-center">平台层的基础数据管理、租户级别的项目配额管理、统一权限管理。 </p>
					</div>
                </el-col>                
          </el-row>
          <section class="program-content">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <img src="@/assets/img/pro/ctm_pic_1.jpg">
                    </el-col>
                    <el-col :span="12">
                        <div class="program-des">
							<h4>CTM 系统与其他子系统的关系</h4>
                            <h6>基础模块，开箱即用</h6>
							<p>统一门户，统一入口</p>
							<p>iTrial产品的底座，与子系统自由组合使用</p>
                            <p>集成了统一账号、权限和配置管理</p>
						</div>
                    </el-col>
                </el-row>
          </section>
      </div>
    </div>
</template>
<script>

export default{
    data() {
        return {

        };
    },
    methods: {
      
    }
}
</script>
<style scoped>
.program-des {
    padding: 60px 30px 0;
    text-align: center;
}
.program-des h4{
  margin-bottom: 30px;
}
</style>